import { Component, OnInit } from '@angular/core';
import { ConfirmDialogService, ConfirmDialogState } from './confirm-dialog.service';

//declare var require: any;
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent implements OnInit {

  // title: string;
  // content: string;
  // value: any;
  icon;
  state;
  // @Output('confirmEvent')
  // confirmEvent = new EventEmitter<any>();

  // @Output('cancelEvent')
  // cancelEvent = new EventEmitter<any>();

  constructor(
    private _confirmDialogService: ConfirmDialogService
  ) {
    this.icon =  "./assets/icons/emoji1.png"; //require('../icons/emoji1.png');
  }

  ngOnInit() {
    this._confirmDialogService.confirmDialogSource$.subscribe(state => {
      this.state = state;
    });
  }

  onConfirm() {
    this.state.state = ConfirmDialogState.Confirmed;
    this._confirmDialogService.setState(this.state);
  }

  onCancel() {
    this.state.state = ConfirmDialogState.Cancalled;
    this._confirmDialogService.setState(this.state);
  }
}
